//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    videos: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  data() {
    return {
      videoModal: {
        display: false,
        show: false,
        url: ''
      }
    }
  },

  methods: {
    openVideo(video) {
      this.videoModal.display = !this.videoModal.display
      this.videoModal.url = video.url

      setTimeout(() => (this.videoModal.show = !this.videoModal.show), 200)
    },

    closeVideo() {
      this.videoModal.show = !this.videoModal.show

      setTimeout(
        () => (this.videoModal.display = !this.videoModal.display),
        300
      )
    }
  }
}
